import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import  LanguageProvider  from './contexts/LanguageContext'
// import { Home } from './container';
import routes from './RootRoutes'
import history from './history.js'
import { SuspenseComponent } from './components';
import { AnimatedRoutes } from './components';
// import PageAboutBakery from './container/AboutBakery/PageAboutBakery';
import './App.css';

const App = () => (

  <AppContext.Provider value={{ routes }}> {/*Contexto que contiene las rutas*/}
    <LanguageProvider>
      <Router history={history} basename={process.env.PUBLIC_URL}>
        <SuspenseComponent>
          <AnimatedRoutes />
        </SuspenseComponent>
      </Router>
    </LanguageProvider>
  </AppContext.Provider>


);

export default App;
